import './style.scss';
import { Header } from './Header';

// get the header element
const headerEl = document.querySelector('body > header');

//
new Header(headerEl as HTMLElement);
